class FaqCategorized extends HTMLElement {
  connectedCallback() {
    this.items = this.querySelectorAll(".faq-categorized__item");

    if (!this.items.length) return;

    this.items.forEach((item) => {
      const button = item.querySelector(".faq-categorized__question");
      if (!button) return;

      button.addEventListener("click", () => {
        const isOpen = item.classList.contains("is-open");
        item.classList.toggle("is-open", !isOpen);
        button.setAttribute("aria-expanded", String(!isOpen));
      });
    });
  }
}

if (!customElements.get("faq-categorized")) {
  customElements.define("faq-categorized", FaqCategorized);
}
